var _rect, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowserWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 2,
    fill: "white",
    stroke: "#C8CBD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H30",
    stroke: "#C8CBD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 5.13132 4.02587 5.26136 4.07612 5.38268C4.12638 5.50401 4.20003 5.61425 4.29289 5.70711C4.38575 5.79996 4.49599 5.87362 4.61732 5.92388C4.73864 5.97413 4.86868 6 5 6C5.13132 6 5.26136 5.97413 5.38268 5.92388C5.50401 5.87362 5.61425 5.79996 5.70711 5.70711C5.79997 5.61425 5.87362 5.50401 5.92388 5.38268C5.97413 5.26136 6 5.13132 6 5C6 4.86868 5.97413 4.73864 5.92388 4.61732C5.87362 4.49599 5.79997 4.38575 5.70711 4.29289C5.61425 4.20003 5.50401 4.12638 5.38268 4.07612C5.26136 4.02587 5.13132 4 5 4C4.86868 4 4.73864 4.02587 4.61732 4.07612C4.49599 4.12638 4.38575 4.20003 4.29289 4.29289C4.20003 4.38575 4.12638 4.49599 4.07612 4.61732C4.02587 4.73864 4 4.86868 4 5Z",
    fill: "#C8CBD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 5.26522 7.10536 5.51957 7.29289 5.70711C7.48043 5.89464 7.73478 6 8 6C8.26522 6 8.51957 5.89464 8.70711 5.70711C8.89464 5.51957 9 5.26522 9 5C9 4.73478 8.89464 4.48043 8.70711 4.29289C8.51957 4.10536 8.26522 4 8 4C7.73478 4 7.48043 4.10536 7.29289 4.29289C7.10536 4.48043 7 4.73478 7 5Z",
    fill: "#C8CBD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 5.26522 10.1054 5.51957 10.2929 5.70711C10.4804 5.89464 10.7348 6 11 6C11.2652 6 11.5196 5.89464 11.7071 5.70711C11.8946 5.51957 12 5.26522 12 5C12 4.73478 11.8946 4.48043 11.7071 4.29289C11.5196 4.10536 11.2652 4 11 4C10.7348 4 10.4804 4.10536 10.2929 4.29289C10.1054 4.48043 10 4.73478 10 5Z",
    fill: "#C8CBD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19750_13320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1717 11.6666L10.5137 13.6408L11.0052 12.4761L13.1717 11.6666Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03587 11.6666L9.67257 13.6595L9.20507 12.4761L7.03587 11.6666ZM12.2157 16.2428L11.5078 17.3274L13.0225 17.7441L13.458 16.2668L12.2157 16.2428ZM6.75537 16.2668L7.18814 17.7441L8.70285 17.3274L7.99492 16.2428L6.75537 16.2668Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61739 14.4102L8.19531 15.0487L9.69931 15.1155L9.64589 13.4993L8.61739 14.4102ZM11.5907 14.4102L10.5488 13.4806L10.5141 15.1155L12.0154 15.0487L11.5907 14.4102ZM8.70289 17.3274L9.60581 16.8866L8.82576 16.2776L8.70289 17.3274ZM10.6023 16.8866L11.5079 17.3274L11.3823 16.2776L10.6023 16.8866Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5081 17.3274L10.6025 16.8866L10.6746 17.477L10.6666 17.7254L11.5081 17.3274ZM8.70312 17.3274L9.54463 17.7254L9.53928 17.477L9.60605 16.8866L8.70312 17.3274Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55804 15.8874L8.80469 15.6657L9.33631 15.4226L9.55804 15.8874ZM10.6506 15.8874L10.8724 15.4226L11.4067 15.6657L10.6506 15.8874Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70255 17.3273L8.8308 16.2427L7.99463 16.2668L8.70255 17.3273ZM11.3793 16.2427L11.5076 17.3273L12.2155 16.2668L11.3793 16.2427ZM12.0151 15.0486L10.5138 15.1154L10.6527 15.8874L10.8744 15.4226L11.4087 15.6657L12.0151 15.0486ZM8.80408 15.6657L9.33835 15.4226L9.55743 15.8874L9.699 15.1154L8.195 15.0486L8.80408 15.6657Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19531 15.0486L8.82576 16.2774L8.80439 15.6657L8.19531 15.0486ZM11.409 15.6657L11.3823 16.2774L12.0154 15.0486L11.409 15.6657ZM9.69931 15.1154L9.55774 15.8874L9.73404 16.7984L9.77411 15.5989L9.69931 15.1154ZM10.5141 15.1154L10.442 15.5962L10.474 16.7984L10.653 15.8874L10.5141 15.1154Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 15.8874L10.4743 16.7983L10.6026 16.8865L11.3826 16.2774L11.4093 15.6656L10.6533 15.8874ZM8.80469 15.6656L8.82606 16.2774L9.60611 16.8865L9.73434 16.7983L9.55804 15.8874L8.80469 15.6656Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 17.7255L10.6746 17.4771L10.6078 17.4183H9.60073L9.53928 17.4771L9.54463 17.7255L8.70312 17.3275L8.99698 17.5679L9.5927 17.982H10.6158L11.2142 17.5679L11.5081 17.3275L10.6666 17.7255Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6023 16.8866L10.4741 16.7985H9.73409L9.60586 16.8866L9.53906 17.477L9.60051 17.4182H10.6076L10.6744 17.477L10.6023 16.8866Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2843 13.769L13.5113 12.6791L13.1721 11.6666L10.6022 13.574L11.5906 14.4102L12.9877 14.8189L13.2976 14.4583L13.164 14.3621L13.3778 14.1671L13.2121 14.0389L13.4258 13.8759L13.2843 13.769ZM6.69922 12.6791L6.92629 13.769L6.78203 13.8759L6.99575 14.0389L6.83279 14.1671L7.0465 14.3621L6.91293 14.4583L7.22014 14.8189L8.6173 14.4102L9.60572 13.574L7.03582 11.6666L6.69922 12.6791Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9878 14.819L11.5906 14.4103L12.0154 15.0488L11.3823 16.2776L12.2157 16.2669H13.458L12.9878 14.819ZM8.61735 14.4103L7.2202 14.819L6.75537 16.2669H7.99492L8.82572 16.2776L8.19527 15.0488L8.61735 14.4103ZM10.5141 15.1155L10.6022 13.5741L11.0083 12.4762H9.20507L9.60577 13.5741L9.69927 15.1155L9.73135 15.6017L9.734 16.7985H10.474L10.4793 15.6017L10.5141 15.1155Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.106857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19750_13320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7878 15.2607C26.0636 14.6419 24.6918 12.9048 23.3796 12.1891C22.5521 11.6299 21.6947 11.7045 21.5157 11.9505C21.1355 12.4873 22.7832 12.9495 23.8866 13.4789C23.648 13.5833 23.4244 13.7696 23.2976 14.0008C22.8876 13.5534 21.9854 13.1657 20.9268 13.4789C20.211 13.6876 19.622 14.1871 19.3909 14.9327C19.3387 14.9103 19.2716 14.8954 19.212 14.8954C18.9659 14.8954 18.7646 15.0967 18.7646 15.3428C18.7646 15.5888 18.9659 15.7901 19.212 15.7901C19.2567 15.7901 19.3984 15.7603 19.3984 15.7603L21.6947 15.7752C20.7776 17.2365 20.047 17.4452 20.047 17.6987C20.047 17.9522 20.7404 17.8851 21.0013 17.7882C22.2538 17.3408 23.5958 15.9317 23.827 15.5291C24.7962 15.6559 25.6088 15.6633 25.7878 15.2607Z",
    fill: "url(#paint0_linear_19750_13320)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8942 13.4788C23.9464 13.4564 23.9389 13.3818 23.924 13.3222C23.8942 13.188 23.335 12.6363 22.8132 12.3903C22.0974 12.0548 21.5755 12.0697 21.501 12.2262C21.6426 12.5245 22.3211 12.8003 23.0219 13.0985C23.3127 13.2178 23.6184 13.3446 23.8942 13.4788Z",
    fill: "url(#paint1_linear_19750_13320)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9846 16.4761C22.843 16.4239 22.679 16.3717 22.4926 16.3269C22.6864 15.9765 22.7311 15.4472 22.5448 15.1192C22.2838 14.6569 21.9558 14.4109 21.1878 14.4109C20.7703 14.4109 19.6371 14.5525 19.6147 15.4994C19.6147 15.5963 19.6147 15.6858 19.6222 15.7752H21.6948C21.419 16.2151 21.158 16.5432 20.9269 16.7892C21.2028 16.8563 21.4264 16.9159 21.6352 16.9756C21.829 17.0278 22.0154 17.0725 22.2018 17.1247C22.4851 16.9159 22.7535 16.6923 22.9846 16.4761Z",
    fill: "url(#paint2_linear_19750_13320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.361 15.6635C19.443 16.3792 19.853 16.6625 20.6881 16.7445C21.5231 16.8266 22.0002 16.7744 22.6339 16.8266C23.1633 16.8713 23.6404 17.1471 23.8119 17.0502C23.9685 16.9682 23.879 16.6625 23.6703 16.4687C23.3944 16.2152 23.0142 16.0437 22.3506 15.9766C22.4848 15.6113 22.4476 15.0969 22.2388 14.821C21.9406 14.4184 21.3889 14.2395 20.6881 14.314C19.9574 14.4035 19.2566 14.7688 19.361 15.6635Z",
    fill: "url(#paint3_linear_19750_13320)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_19750_13320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19750_13320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 20,
    width: 8,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H14V28H6V20Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19750_13320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19750_13320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 20,
    width: 8,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H14V28H6V20Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19750_13320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_19750_13320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 20,
    width: 8,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78913 20H11.2109C12.014 20 12.4155 20 12.8478 20.1367C13.3198 20.3085 13.6915 20.6802 13.8633 21.1522C14 21.5845 14 21.9861 14 22.7891V25.2109C14 26.014 14 26.4155 13.8633 26.8478C13.6915 27.3198 13.3198 27.6915 12.8478 27.8633C12.4155 28 12.014 28 11.2109 28H8.78913C7.986 28 7.58453 28 7.1522 27.8633C6.6802 27.6915 6.30847 27.3198 6.13667 26.8478C6 26.4155 6 26.014 6 25.2109V22.7891C6 21.9861 6 21.5845 6.13667 21.1522C6.30847 20.6802 6.6802 20.3085 7.1522 20.1367C7.58453 20 7.986 20 8.78913 20Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_19750_13320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20H14V28H6V20Z",
    fill: "url(#paint4_linear_19750_13320)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 22.5334H12.2665C10.2046 22.5334 8.53317 24.2048 8.53317 26.2667V26.6667H7.73317C7.51226 26.6667 7.33317 26.4876 7.33317 26.2667C7.33317 23.5421 9.5419 21.3334 12.2665 21.3334C12.4874 21.3334 12.6665 21.5125 12.6665 21.7334V22.5334Z",
    fill: "url(#paint5_radial_19750_13320)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 26.2667H7.33324C7.33324 26.4876 7.51232 26.6667 7.73324 26.6667H8.3999V26.2667Z",
    fill: "url(#paint6_linear_19750_13320)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2665 21.3334V22.4H12.6665V21.7334C12.6665 21.5125 12.4874 21.3334 12.2665 21.3334Z",
    fill: "url(#paint7_linear_19750_13320)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 22.4H12.2665C10.131 22.4 8.39984 24.1312 8.39984 26.2667V26.6667H9.59984V26.2667C9.59984 24.7939 10.7937 23.6 12.2665 23.6H12.6665V22.4Z",
    fill: "url(#paint8_radial_19750_13320)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4668 26.2667H8.40013V26.6667H9.4668V26.2667Z",
    fill: "url(#paint9_linear_19750_13320)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 23.4667V22.4H12.2665V23.4667H12.6665Z",
    fill: "url(#paint10_linear_19750_13320)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 24.1333C12.6665 24.3543 12.4874 24.5333 12.2665 24.5333C11.3092 24.5333 10.5332 25.3094 10.5332 26.2667C10.5332 26.4876 10.3541 26.6667 10.1332 26.6667H9.4665V26.2667C9.4665 24.7203 10.7201 23.4667 12.2665 23.4667H12.6665V24.1333Z",
    fill: "url(#paint11_radial_19750_13320)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 26.2667H9.46654V26.6667H10.1332C10.3541 26.6667 10.5332 26.4876 10.5332 26.2667Z",
    fill: "url(#paint12_radial_19750_13320)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2665 24.5333C12.4874 24.5333 12.6665 24.3543 12.6665 24.1333V23.4667H12.2665V24.5333Z",
    fill: "url(#paint13_radial_19750_13320)"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_19750_13320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_19750_13320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 8,
    height: 8
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20H18V28H26V20Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_19750_13320)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20H19C18.4477 20 18 20.4477 18 21V27C18 27.5523 18.4477 28 19 28H25C25.5523 28 26 27.5523 26 27V21C26 20.4477 25.5523 20 25 20Z",
    fill: "#3375BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_19750_13320",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 8,
    height: 9
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9262 19.9999H18.0493V27.8768H25.9262V19.9999Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_19750_13320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9878 27.8768C24.1629 27.8768 25.9262 26.1135 25.9262 23.9383C25.9262 21.7632 24.1629 19.9999 21.9878 19.9999C19.8126 19.9999 18.0493 21.7632 18.0493 23.9383C18.0493 26.1135 19.8126 27.8768 21.9878 27.8768Z",
    fill: "#3375BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8578 21.5341C21.9492 21.4579 22.0821 21.4579 22.1734 21.5342C22.8426 22.093 23.6057 22.0887 23.9009 22.087C23.9157 22.087 23.9292 22.0869 23.9416 22.0869C24.0075 22.0869 24.0707 22.1133 24.1169 22.1603C24.1632 22.2073 24.1887 22.2708 24.1877 22.3368C24.1737 23.263 24.1366 23.9241 24.0637 24.4086C23.9909 24.8928 23.8793 25.2247 23.6994 25.4747C23.5182 25.7265 23.2854 25.8694 23.0374 26.0065C22.9945 26.0302 22.9507 26.054 22.9058 26.0783C22.6882 26.1963 22.4463 26.3276 22.1591 26.5336C22.0733 26.5951 21.9579 26.5951 21.8721 26.5336C21.5853 26.3278 21.3437 26.1966 21.1264 26.0786C21.0813 26.0542 21.0373 26.0303 20.9941 26.0064C20.7464 25.8693 20.5138 25.7263 20.333 25.4745C20.1535 25.2244 20.0423 24.8926 19.9697 24.4085C19.8971 23.924 19.8602 23.263 19.8462 22.3368C19.8452 22.2708 19.8707 22.2073 19.917 22.1603C19.9632 22.1133 20.0264 22.0869 20.0923 22.0869C20.1045 22.0869 20.118 22.087 20.1326 22.087C20.4254 22.0887 21.1886 22.0931 21.8578 21.5341ZM20.3429 22.5777C20.3594 23.3671 20.3954 23.9269 20.4566 24.3355C20.5241 24.7861 20.6192 25.029 20.7329 25.1874C20.8453 25.3439 20.9928 25.4431 21.2325 25.5756C21.2715 25.5972 21.3126 25.6195 21.3559 25.643C21.5402 25.7429 21.762 25.8632 22.0156 26.0338C22.2696 25.863 22.4918 25.7426 22.6764 25.6426C22.7194 25.6193 22.7604 25.5971 22.7993 25.5756C23.0392 25.443 23.1871 25.3438 23.2998 25.1871C23.4138 25.0287 23.5092 24.7859 23.5769 24.3354C23.6383 23.9268 23.6744 23.3671 23.691 22.5777C23.312 22.5655 22.6446 22.4872 22.0156 22.0345C21.3874 22.4867 20.7209 22.5653 20.3429 22.5777Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19750_13320",
    x1: 20.8509,
    y1: 14.6834,
    x2: 25.7377,
    y2: 16.0692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8797FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19750_13320",
    x1: 24.7336,
    y1: 14.7927,
    x2: 21.2075,
    y2: 11.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B22A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5156D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19750_13320",
    x1: 23.0819,
    y1: 16.6038,
    x2: 19.6947,
    y2: 14.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B1E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6FFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19750_13320",
    x1: 20.6147,
    y1: 15.0854,
    x2: 22.9042,
    y2: 17.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9839,
    stopColor: "#5F47F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19750_13320",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_19750_13320",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2665 26.2667) rotate(-90) scale(4.93333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.770277,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19750_13320",
    x1: 8.46657,
    y1: 26.4667,
    x2: 7.33324,
    y2: 26.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19750_13320",
    x1: 12.4665,
    y1: 21.3334,
    x2: 12.4665,
    y2: 22.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8754C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_19750_13320",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2665 26.2667) rotate(-90) scale(3.86667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.723929,
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19750_13320",
    x1: 9.4668,
    y1: 26.4667,
    x2: 8.40013,
    y2: 26.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19750_13320",
    x1: 12.4665,
    y1: 23.4667,
    x2: 12.4665,
    y2: 22.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_19750_13320",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2665 26.2667) rotate(-90) scale(2.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59513,
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_19750_13320",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5999 26.4667) rotate(180) scale(1.13333 3.02222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_19750_13320",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4665 24.6) rotate(-90) scale(1.13333 21.4913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19750_13320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19750_13320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(17 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_19750_13320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(-1 0 0 1 14 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_19750_13320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(18 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserWallet);
export default __webpack_public_path__ + "static/media/browser-wallet.4e6189f359cd0724630468473047701b.svg";
export { ForwardRef as ReactComponent };